<template>
  <div class="mains">
    <div style="text-align:right;padding-right:300px;"
         v-if="details==true">
      <el-button type="primary"
                 @click="details=false">编辑</el-button>
    </div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             style="margin-top:20px; width: 600px;">
      <el-form-item label="店铺背景:"
                    prop='shopBack'
                    :label-width="formLabelWidth">
        <el-upload style="display: inline-block"
                   action="#"
                   :disabled='details==true'
                   :file-list="ruleForm.shopBackFile"
                   :multiple="true"
                   list-type="picture-card"
                   :on-change="handleChange"
                   :auto-upload="false"
                   :on-preview="handlePictureCardPreview"
                   :on-remove="handleRemove"
                   :class="ruleForm.shopBackFile.length == 1 ? 'mf' : ''"
                   :limit="1">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="品牌标识:"
                    prop='shopBrand'
                    :label-width="formLabelWidth">
        <el-upload style="display: inline-block"
                   action="#"
                   :disabled='details==true'
                   :file-list="ruleForm.shopBrandFile"
                   :multiple="true"
                   list-type="picture-card"
                   :on-change="handleChange2"
                   :auto-upload="false"
                   :on-preview="handlePictureCardPreview"
                   :class="ruleForm.shopBrandFile.length == 1 ? 'mf' : ''"
                   :on-remove="handleRemove2"
                   :limit="1">
          <!--  :disabled="optType == 'detail'" -->
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="品牌介绍标题:"
                    :label-width="formLabelWidth">
        <el-input type="textarea"
                  :disabled='details'
                  v-model="ruleForm.shopTitle"
                  maxlength="20"
                  :autosize="{ minRows: 2}"
                  show-word-limit
                  placeholder="品牌介绍标题"></el-input>
      </el-form-item>
      <el-form-item label="品牌介绍:"
                    :label-width="formLabelWidth">
        <el-input type="textarea"
                  :disabled='details'
                  v-model="ruleForm.shopContent"
                  maxlength="280"
                  :autosize="{ minRows: 6}"
                  show-word-limit
                  placeholder="输入介绍内容"></el-input>
      </el-form-item>
      <div class="btn"
           v-if="details==false">
        <el-button @click="details = true">取消</el-button>
        <el-button type="primary"
        :loading='loading'
                   @click="submitHandle">保存</el-button>
      </div>
    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="dialogImageUrl"
           alt="" />
    </el-dialog>
  
  </div>
</template>

<script>

import { mapActions } from "vuex";
export default {
  props: {

  },
  data () {
    return {
      formLabelWidth: '120px',
      details: true,
      dialogImageUrl: "",
      dialogVisible: false,  
      loading: false,
      
      ruleForm: {
        shopBack: '',
        shopBackFile: [],
        shopBrand: '',
        shopBrandFile: [],
        shopTitle: '',
        shopContent: ''
      },
      rules: {
        shopBackFile: [
          { required: true, trigger: 'blur', message: '请输入店铺背景' }
        ],
        shopBrandFile: [
          { required: true, trigger: 'blur', message: '请输入品牌标识' }
        ],
        shopTitle: [
          { required: true, trigger: 'blur', message: '品牌介绍标题' }
        ],
        shopContent: [
          { required: true, trigger: 'blur', message: '品牌介绍' }
        ],

      },
    };
  },
  mounted () {
    this.getdecorateList()
  },
  methods: {
    ...mapActions({
      decorateList: "detect/decorateList",
      decorateShopEdit: "detect/decorateShopEdit",
      uploadFile: "commodity/uploadFile",
    }),
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange (file, fileList) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.ruleForm.shopBackFile = fileList;
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          this.$message.success("上传成功！");
          this.ruleForm.shopBack = res.data.formdata_details[0].urls;
        } else {
          this.ruleForm.shopBackFile = []
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
      /* var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.ruleForm.zhuFile = fileList; */
    },
    handleChange2 (file, fileList) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.ruleForm.shopBrandFile = fileList;
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          this.$message.success("上传成功！");
          this.ruleForm.shopBrand = res.data.formdata_details[0].urls;
        } else {
          this.ruleForm.shopBrandFile = []
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
      /* var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.ruleForm.zhuFile = fileList; */
    },
    handleRemove (file, fileList) {
      this.ruleForm.shopBackFile = []
      this.ruleForm.shopBack = ''
    },
    handleRemove2 (file, fileList) {
      this.ruleForm.shopBrandFile = []
      this.ruleForm.shopBrand = ''
    },
    submitHandle () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.getdecorateShopEdit()
        } else {
          return false;
        }
      });
    },
    //编辑
    getdecorateShopEdit () {
      this.loading=true
      let params = {
        token: this.$store.state.token,
        shop_id: this.$route.query.id,
        shop_background: this.ruleForm.shopBack,
        shop_brand_img: this.ruleForm.shopBrand,
        shop_brand_describe: this.ruleForm.shopContent,
        shop_brand_title: this.ruleForm.shopTitle
      }
      this.decorateShopEdit(params).then(res => {
          this.loading=false
       
        if (res.data.code == 1) {
          this.details = true
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
    //详情
    getdecorateList () {
      let params = {
        token: this.$store.state.token,
        shop_id: this.$route.query.id
      }
      this.decorateList(params).then(res => {
        this.details = true
  
        if (res.data.code == 1) {
          this.ruleForm.shopBack = res.data.data.shop_background
          this.ruleForm.shopBackFile = [{
            url: res.data.data.shop_background
          }]
          this.ruleForm.shopBrand = res.data.data.shop_brand_img
          this.ruleForm.shopBrandFile = [{
            url: res.data.data.shop_brand_img
          }]
          this.ruleForm.shopTitle = res.data.data.shop_brand_title
          this.ruleForm.shopContent = res.data.data.shop_brand_describe
        } else {
          this.$message.error(res.data.msg);
        }

      })
    }
  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.mains {
  // width: 800px;
  margin-left: 60px;
}
.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
